export const mutations = {
  SET_CAMPAIGNS (state, campaigns) {
    state.campaigns = campaigns
  },
  SET_CAMPAIGNS_COUNTS (state, counts) {
    state.campaignsCounts = counts
  },
  UPDATE_CAMPAIGNS_AUDIENCE (state, data) {
    console.log('UPDATE_CAMPAIGNS_AUDIENCE state: ', state)
    console.log('UPDATE_CAMPAIGNS_AUDIENCE data: ', data)
    const campaign = state.campaigns.result.filter(campaign => campaign.projectId === data.projectId)
    campaign[0].audienceId = data.response.audienceId
  },
  SET_PRIMARY_CAMPAIGNS (state, primaryCampaigns) {
    state.primaryCampaigns = primaryCampaigns
  },
  SET_SUB_CAMPAIGNS (state, subCampaigns) {
    state.subCampaigns = subCampaigns
  },
  SET_CAMPAIGN_SUMMARY (state, summaryDetails) {
    state.campaign.summaryDetails = summaryDetails
  },
  SET_MESSAGE_SUMMARY (state, messageDetails) {
    state.campaign.messageDetails = messageDetails
  },
  SET_MESSAGE_HISTORY (state, history) {
    state.message.history = history
  },
  SET_MESSAGE_AUDIENCE (state, audience) {
    state.campaign.audience = audience
  },
  SET_MESSAGE_COUNT_GENERATING (state, countGenerating) {
    state.campaign.countGenerating = countGenerating
  },
  SET_CAMPAIGN_HISTORY (state, history) {
    state.campaign.history = history
  },
  SET_CAMPAIGN_AUDIENCE (state, audience) {
    state.campaign.audience = audience
  },
  SET_CAMPAIGN_AUDIENCE_FILTERS (state, filters) {
    state.campaign.audience.filters = filters
  },
  SET_AUDIENCE_SUMMARY (state, audienceSummary) {
    state.audienceSummary = audienceSummary
  },
  SET_CAMPAIGN_AUDIENCE_CUSTOMERS (state, customers) {
    state.campaign.customers = customers
  },
  SET_MESSAGING_AUDIENCE_SUMMARY (state, audienceSummary) {
    state.messagingAudienceSummary = audienceSummary
  },
  SET_CAMPAIGN_AUDIENCE_DYNAMICQUERY (state, dynamicQuery) {
    state.campaign.dynamicQuery = dynamicQuery
  },
  SET_CAMPAIGN_COUNT_GENERATING (state, countGenerating) {
    state.campaign.countGenerating = countGenerating
  },
  SET_CAMPAIGN_CONTENT (state, content) {
    state.campaign.content = content
  },
  SET_CAMPAIGN_REPORT (state, report) {
    state.campaign.report = report
  },
  SET_BASIC_VALIDATION (state, basicValidation) {
    state.campaign.basicValidation = basicValidation
  },
  SET_CAMPAIGN_INBOX_PREVIEW_AND_FORECASTER (state, inboxPreviewAndForecaster) {
    state.campaign.inboxPreviewAndForecaster = inboxPreviewAndForecaster
  },
  SET_GRIDSELECTEDCAMPAIGNS (state, campaign) {
    state.gridSelectedCampaign = campaign
  },
  SET_MESSAGING_GRIDSELECTEDCAMPAIGNS (state, campaign) {
    state.messagingGridSelectedCampaign = campaign
  },
  SET_ISTRANSACTIONAL (state, isTransactional) {
    state.isTransactional = isTransactional
  },
  SET_ISPRIMARY (state, isPrimary) {
    state.isPrimary = isPrimary
  },
  SET_CLIENTID (state, clientId) {
    state.clientId = clientId
  },
  SET_COMPANYID (state, companyId) {
    state.companyId = companyId
  },
  SET_ENV_NAME (state, env) {
    state.environmentName = env
  },
  SET_EINSIGHT_URI (state, einsightUri) {
    state.einsightUri = einsightUri
  },
  SET_APP_CONFIG (state, appConfig) {
    state.appConfig = appConfig
  },
  SET_LOADING (state, loading) {
    state.loading += (loading ? 1 : -1)
  },
  SET_LOADING_CUSTOMERS (state, loading) {
    state.loadingCustomers = loading
  },
  SET_LOCALE (state, locale) {
    state.locale = locale
  },
  SET_DATE_FORMAT (state, dateFormat) {
    state.dateFormat = dateFormat
  },
  SET_TIME_FORMAT (state, timeFormat) {
    state.timeFormat = timeFormat
  },
  SET_USER_EMAIL (state, userEmail) {
    state.userEmail = userEmail
  },
  SET_VALIDATION_CAMPAIGN_ID (state, compaignId) {
    state.validationCampaignId = compaignId
  },
  SET_GRID_LOADED (state, gridLoaded) {
    state.gridLoaded = gridLoaded
  },
  SET_CAMPAIGN_JOURNEY (state, campaignJourney) {
    state.campaignJourney = campaignJourney
  },
  SET_TIMEZONE_FEATURE (state, timezoneEnable) {
    state.campaignTimezoneEnable = timezoneEnable
  },
  DELETE_CAMPAIGN (state, projectId) {
    // console.log('state.campaigns: ', state.campaigns)
    // state.campaigns = state.campaigns.filter(campaign => campaign.projectId !== projectId)
    // state.gridLoaded = false
  },
  SET_USER_ACCESS_CONTROL (state, accessControl) {
    // console.log('SET_USER_ACCESS_CONTROL: ', accessControl)
    state.userAccessControl = accessControl
  },
  SET_TRANSACTIONAL_TEST_MODE (state, transactionalMailingInTestMode) {
    state.transactionalMailingInTestMode = transactionalMailingInTestMode
  },
  SET_HAS_EMAIL_CONTENT_APPROVAL (state, hasEmailContentApproval) {
    state.hasEmailContentApproval = hasEmailContentApproval
  },
  SET_IS_INBOX_FORECASTER_ENABLED (state, isInboxForecasterEnabled) {
    // console.log('SET_IS_INBOX_FORECASTER_ENABLED: ', isInboxForecasterEnabled)
    state.isInboxForecasterEnabled = isInboxForecasterEnabled
  },
  SET_LANDING_TAB (state, landingTab) {
    state.landingTab = landingTab
  },
  SET_ACCOUNT_ID (state, accountId) {
    state.accountId = accountId
  },
  SET_CURRENT_CHILD_TEMPLATE_ID (state, currentChildTemplateId) {
    state.currentChildTemplateId = currentChildTemplateId
  },
  SET_FILTERS_DATA (state, filtersData) {
    state.filtersData = filtersData
  },
  SET_MESSAGING_FILTERS_DATA (state, filtersData) {
    state.messagingFiltersData = filtersData
  },
  SET_SMS_MESSAGING (state, SMS) {
    state.SMSMessaging = SMS
  },
  SET_WHATSAPP_MESSAGING (state, WHATSAPP) {
    state.WhatsAppMessaging = WHATSAPP
  },
  SET_HAS_SALES (state, sales) {
    state.hasSalesCampaign = sales
  },
  SET_MESSAGING_CAMPAIGNS (state, campaigns) {
    state.messagingCampaigns = campaigns
  },
  SET_MESSAGING_CAMPAIGNS_COUNTS (state, counts) {
    state.messagingCampaignsCounts = counts
  },
  SET_MESSAGING_CHANNEL (state, channel) {
    state.messagingChannel = channel
  },
  SET_B2B_CAMPAIGN_TYPE (state, campaignType) {
    state.b2bCampaignType = campaignType
  },
  SET_EMAIL_CAMPAIGN_TYPE (state, EcampaignType) {
    state.emailCampaignType = EcampaignType
  },
  SET_SECONDARY_CAMPAIGN_TYPE (state, campaignType) {
    state.secondaryCampaignKey = campaignType
  },
  SET_APPROVER_PERMISSION (state, isApprover) {
    state.hasApproverPermission = isApprover
  },
  SET_OKTA_TOKEN (state, oktaToken) {
    state.oktaToken = oktaToken
  },
  SET_MESSAGING_BASE_URL (state, messagingBaseUrl) {
    state.messagingBaseUrl = messagingBaseUrl
  },
  SET_MESSAGING_ROW_HOVERED (state, messagingRowBeingHovered) {
    state.messagingGridRowHoverData = messagingRowBeingHovered
  },
  SET_MESSAGE_STATISTICS (state, statistics) {
    state.messagingStatistics = statistics
  }
}
